import api from "../services/api";
import Cookies from "js-cookie";
import { formatTrainee } from "../hooks/api/listTrainees";
import { stringToDate } from "../hooks/utils/useFormat";

export default async function getCommercial(
  commercial_id,
  budgetSelect = null,
  params = "",
  preURL = "",
  isReport = false,
) {
  let _token = Cookies.get("user-token");
  _token = _token ? JSON.parse(_token) : null;
  const config = {
    headers: { Authorization: `Bearer ${_token?.token}` },
  };

  if (commercial_id) {
    let _budget_fix = budgetSelect === "new" ? null : budgetSelect;

    const _commercial_raw = !isReport
      ? await api.get(`${preURL}/commercial/${commercial_id}${params}`, config)
      : await api.get(`${preURL}/commercial/general/report/${commercial_id}`, config);

    let _budget_raw = { data: [] };
    let _contribution_raw = { data: [] };
    let _removal_raw = { data: [] };
    let _event_invites_raw = { data: [] };
    if (preURL !== "trainee") {
      _budget_raw = await api.get(
        `budget${_budget_fix ? "/" + _budget_fix : "?main=1&commercial_id=" + commercial_id}`,
        config,
      );
      _contribution_raw = await api.get(`contribution?commercial_id=${commercial_id}`, config);
      _removal_raw = await api.get(`removal?commercial_id=${commercial_id}`, config);
      _event_invites_raw = await api.get(`commercial-event-invite?commercial_id=${commercial_id}`, config);
    }

    // Wallet Stuff
    let _commercial = _commercial_raw.data;
    let _budget = null;

    if (budgetSelect === "new") {
      _budget = null;
    } else if (_budget_fix) {
      _budget = _budget_raw.data;
    } else {
      _budget = _budget_raw.data.length > 0 ? _budget_raw.data[0] : null;
    }

    let _wallet = {
      contribution: {
        cost: _contribution_raw.data.reduce((p, e) => p + e.value, 0),
        data: _contribution_raw.data.map(e => ({
          id: e.id,
          cost: e.value,
          type: e.contribution,
          description: e.description,
          due_date: e.due_date,
          protocol_attendance: e.protocol_attendance,
          user_id: e.user_id,
          trainees: e.trainees?.map(__trainee => ({
            value: __trainee.id,
            label: __trainee.name,
          })),
        })),
      },
      removal: {
        cost: _removal_raw.data.reduce((p, e) => p + e.value, 0),
        data: _removal_raw.data.map(e => ({
          id: e.id,
          cost: e.value,
          type: e.removal,
          description: e.description,
          due_date: e.due_date,
          protocol_attendance: e.protocol_attendance,
          user_id: e.user_id,
        })),
      },
    };

    let _all_events = [];

    let _commercial_packages = _commercial.package;
    let _commercial_singles = _commercial.single;

    let _products = _commercial.customPayments
      .filter(__payment => __payment.payer_type === "produto")
      .map(__payment => {
        const _now = new Date();
        const _date_end = stringToDate(__payment.date_end);
        const _date_start = stringToDate(__payment.date_start);
        return {
          ...__payment,
          status: !!__payment.contribution_done
            ? "Encerrado"
            : _date_end < _now
              ? "Aguardando Finalização"
              : _date_start > _now
                ? "Aguardando Disponibilidade"
                : "Ativo",
        };
      });

    let _custom_payments = _commercial.customPayments
      .filter(__payment => !!__payment.trainee_id)
      .filter(
        __payment =>
          __payment.payer_type === "compra_formando" || // Compra na Loja
          __payment.payer_type === "formando" || // Cobrança pelo Gestor
          __payment.payer_type === "item_adicional", // Item Adicional no Cadastro
      )
      // Convite/Ingresso Extra é um item_adicional tagueado (invite_type preenchido) — fica de
      // fora das listagens genéricas de "Itens Adicionais" (aqui e na Planilha de Custos), já tem
      // tela própria (Convites e Ingressos) e mistura mal com item positivo numa lista de custos
      // quando é um desconto (quantity negativo, de formando que abriu mão da Base).
      .filter(__payment => !__payment.invite_type)
      .map(__payment => ({
        ...__payment,
        value_total: (__payment.value || 0) * (__payment.quantity || 0) + (__payment.convenience_fee || 0),
        payer_type_label:
          __payment.payer_type === "compra_formando"
            ? "Compra"
            : __payment.payer_type === "formando"
              ? "Cobrança"
              : __payment.payer_type === "item_adicional"
                ? "Adicional"
                : "",
      }));

    _commercial_packages.forEach(pkg => {
      pkg.event.forEach(evt => {
        if (!_all_events.find(e => e.id === evt.id)) {
          let _date_event = null;
          if (_commercial.eventDates.length) {
            _date_event = _commercial.eventDates.find(e2 => e2.event_id === evt.id).due_date;
          }
          _all_events.push({
            id: evt.id,
            name: evt.name,
            description: evt.description,
            number_trainees: {
              total: parseInt(pkg.number_trainees),
              per_package: [
                {
                  package_id: pkg.id,
                  package_name: pkg.name,
                  data: parseInt(pkg.number_trainees),
                },
              ],
            },
            category_id: evt.category_id,
            date_event: _date_event ? stringToDate(_date_event) : null,
            only_attendance: evt.categories.only_attendance,
            resources: [],
            cost: {
              total: 0,
              per_package: [],
            },
            custom_payments: _custom_payments.filter(__payment => __payment.event_id === evt.id),
          });
        } else {
          let _event = _all_events.find(e => e.id === evt.id);
          _event.number_trainees.total += parseInt(pkg.number_trainees);
          _event.number_trainees.per_package.push({
            package_id: pkg.id,
            package_name: pkg.name,
            data: parseInt(pkg.number_trainees),
          });
        }
      });
    });

    _commercial_singles.forEach(__event => {
      if (!_all_events.find(e => e.id === __event.event.id)) {
        let _event_date = _commercial?.eventDates?.find(e2 => e2.event_id === __event.event.id)?.due_date;
        _event_date = _event_date ? stringToDate(_event_date) : null;
        _all_events.push({
          id: __event.event.id,
          name: __event.event.name,
          description: __event.event.description,
          number_trainees: {
            total: parseInt(__event.number_trainees),
            per_package: [
              {
                package_id: null,
                package_name: "Avulso",
                data: parseInt(__event.number_trainees),
              },
            ],
          },
          category_id: __event.event.category_id,
          date_event: _event_date, // AQUI
          only_attendance: __event.event.categories.only_attendance,
          resources: [],
          cost: {
            total: 0,
            per_package: [],
          },
        });
      } else {
        let _event = _all_events.find(e => e.id === __event.event.id);
        _event.number_trainees.total += parseInt(__event.number_trainees);
        _event.number_trainees.per_package.push({
          package_id: null,
          package_name: "Avulso",
          data: parseInt(__event.number_trainees),
        });
      }
    });

    let _packages_data = {
      packages: [],
      singles: [],
    };
    let _all_resources = [];

    if (_budget) {
      _budget.package.forEach(__pack => {
        if (__pack.package_id && _commercial.package.some(__package => __package.id === __pack.package_id)) {
          const _package_data_pack = {
            id: __pack.package_id,
            advisory: __pack.advisory,
            reserve_fund: __pack.reserve_fund,
            events: _commercial.package
              .find(e2 => e2.id === __pack.package_id)
              .event.map(e2 => ({
                id: e2.id,
              })),
          };
          _packages_data.packages.push(_package_data_pack);
        } else if (
          __pack.package_single_id &&
          _commercial.single.some(__single => __single.id === __pack.package_single_id)
        ) {
          _packages_data.singles.push({
            id: __pack.package_single_id,
            advisory: __pack.advisory,
            reserve_fund: __pack.reserve_fund,
            resources: [],
          });
        }
      });
      _all_resources = _budget.resource.map(e => ({
        id: e.id,
        resource_id: e.resource_id,
        event_id: e.event_id,
        category_id: e.category_id,
        description: e.description,
        provider_id: e.provider_id,
        qtd: parseInt(e.qtd),
        single_value: e.single_value,
        show: e.show,
        name: e.resources.name,
        in_config: e.resources.in_config,
        only_attendance: e.resources.only_attendance,
        provider_name: e.providers && e.providers.name,
        event_name: e.events && e.events.name,
        custom_payments: _custom_payments.filter(__payment => __payment.resource_id === e.resource_id),
      }));
      _all_resources.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }

    if (_commercial) {
      _commercial.package.forEach(__package => {
        if (!_packages_data.packages.find(el2 => el2.id === __package.id)) {
          _packages_data.packages.push({
            id: __package.id,
            trainee_count: parseInt(__package?.trainee_count),
            advisory: 0,
            reserve_fund: 0,
            events: __package.event.map(e2 => ({
              id: e2.id,
            })),
          });
        }
      });
      _commercial.single.forEach(__single => {
        if (!_packages_data.singles.find(el2 => el2.id === __single.id)) {
          _packages_data.singles.push({
            id: __single.id,
            advisory: 0,
            reserve_fund: 0,
            events:
              __single.event.length > 0 &&
              __single.event.map(e2 => ({
                id: e2.id,
              })),
          });
        }
      });
    }

    _all_resources.forEach(e => {
      let _event = _all_events?.find(e2 => e2.id === e.event_id) || null;
      if (_event) {
        _event.resources.push(e);
        _event.cost.total += e.single_value * e.qtd;
      }
    });

    _all_events = _all_events.map(e => {
      const _event_invite = _event_invites_raw.data?.find(e2 => e2.event_id === e.id);
      return {
        ...e,
        cost: {
          ...e.cost,
          per_package: e.number_trainees.per_package.map(e2 => ({
            package_id: e2.package_id,
            package_name: e2.package_name,
            data: (e.cost.total / e.number_trainees.total) * e2.data,
          })),
        },
        // Expectativa da turma de convites/ingressos por formando para este
        // evento (commercial_event_invites) — usada como ponto de partida na
        // negociação individual de cada formando.
        qtd_invitations: _event_invite?.qtd_invitations ?? null,
        qtd_tickets: _event_invite?.qtd_tickets ?? null,
        value_invitation: _event_invite?.value_invitation ?? null,
        value_ticket: _event_invite?.value_ticket ?? null,
      };
    });

    _commercial.package.forEach(__pack_commercial => {
      _packages_data.packages.forEach((__package, __single_i) => {
        if (__package.id === __pack_commercial.id) {
          _packages_data.packages[__single_i] = {
            ..._packages_data.packages[__single_i],
            name: __pack_commercial.name,
            number_trainees: parseInt(__pack_commercial.number_trainees),
            trainee_count: parseInt(__pack_commercial.trainee_count),
            value_original: __pack_commercial?.value_original || 0,
            value_per_trainee_original: __pack_commercial?.value_per_trainee_original || 0,
            number_of_trainees_original: parseInt(__pack_commercial?.number_of_trainees_original || 0),
          };
        }
      });
    });

    _commercial.single.forEach(__single_commercial => {
      _packages_data.singles.forEach((__single, __single_i) => {
        if (__single.id === __single_commercial.event.id) {
          _packages_data.singles[__single_i] = {
            ..._packages_data.singles[__single_i],
            name: __single_commercial.event.name,
            number_trainees: parseInt(__single_commercial.number_trainees),
            trainee_count: parseInt(__single_commercial.trainee_count),
          };
        }
      });
    });

    // Put Events on Packages & Singles
    _packages_data.packages = _packages_data.packages.map(e => {
      return {
        ...e,
        events: e.events.map(e2 => {
          return _all_events.find(e3 => e3.id === e2.id);
        }),
      };
    });
    _packages_data.singles = _packages_data.singles.map(e => {
      let _single = _commercial_singles.find(e2 => e2.id === e.id);
      if (!!_single) {
        let _event = _all_events.find(e2 => e2.id === _single.event_id);

        let _cost_trainee = _event.cost.total / parseInt(_event.number_trainees.total) + e.advisory + e.reserve_fund;
        let _cost = _cost_trainee * parseInt(_single.number_trainees);

        if (_event) {
          return {
            ...e,
            name: `${_event.name} (Avulso)`,
            category_id: _event.category_id,
            date_event: _event.date_event ? stringToDate(_event.date_event) : null,
            description: _event.description,
            cost_trainee: _cost_trainee,
            cost: _cost,
            resources: _event.resources,
            number_trainees: parseInt(_single.number_trainees),
            trainee_count: parseInt(_single?.trainee_count),
            event_id: _single.event_id,
            event: _event,
            value_original: _single?.value_original || 0,
            value_per_trainee_original: _single?.value_per_trainee_original || 0,
            number_of_trainees_original: parseInt(_single?.number_of_trainees_original || 0),
          };
        }

        return undefined;
      }

      return undefined;
    });

    // Put Values & First Event on Packages
    _packages_data.packages = _packages_data.packages.map(__package => {
      let _cost = 0;
      let _per_trainee_cost = __package.advisory + __package.reserve_fund;
      let _first_event = null;

      __package.events.forEach(e2 => {
        _per_trainee_cost += e2.cost.total / e2.number_trainees.total;
        if (e2.date_event < _first_event || !_first_event) {
          _first_event = e2.date_event;
        }
      });

      _cost = _per_trainee_cost * __package.number_trainees;

      return {
        ...__package,
        cost_trainee: _per_trainee_cost,
        cost: _cost,
        first_event: _first_event,
      };
    });

    // Packages & Singles do trainee
    let _all_trainees = _commercial.trainee.map(__trainee => {
      let _trainee = {
        ...__trainee,
        packages_data: {
          package:
            __trainee.packages.length > 0
              ? _packages_data.packages.find(e2 => e2.id === __trainee.packages[0].id)
              : null,
          singles: __trainee.packageSingle.map(__single => _packages_data.singles.find(e3 => e3.id === __single.id)),
        },
      };
      _trainee = formatTrainee(_trainee);
      delete _trainee.packages;
      delete _trainee.packageSingle;

      return _trainee;
    });
    // Custo Total Commercial && Events Per Package Cost

    // Get 30 days before the First Event
    if (_all_events.length > 1) {
      _all_events.sort(function (a, b) {
        return a.date_event > b.date_event;
      });
    }
    let _first_event = null;
    let _before_event = null;
    if (_all_events.length > 0) {
      _first_event = _all_events[0].date_event;
      _before_event = _first_event
        ? new Date(_first_event.getFullYear(), _first_event.getMonth(), _first_event.getDate() - 30)
        : null;
    }
    _all_events.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    // Organize Supliers Return
    let _supliers = [];
    _all_resources.forEach(__resource => {
      let suplier = _supliers.find(__e => __e.id === __resource.provider_id);
      let resource = {
        id: __resource.id,
        resource_id: __resource.resource_id,
        name: __resource.name,
        qtd: __resource.qtd,
        single_value: __resource.single_value,
      };

      if (suplier) {
        let event = suplier.events.find(__e => __e.id === __resource.event_id);
        if (event) {
          event.resources.push(resource);
        } else {
          suplier.events.push({
            id: __resource.event_id,
            name: __resource.event_name,
            resources: [resource],
          });
        }
      } else {
        _supliers.push({
          id: __resource.provider_id,
          name: __resource.provider_name,
          events: [
            {
              id: __resource.event_id,
              name: __resource.event_name,
              resources: [resource],
            },
          ],
        });
      }
    });
    _supliers.sort(function (a, b) {
      return a.id < b.id;
    });

    // Commercial  Object Mount
    let _total = _packages_data.packages.reduce((p, e) => p + e.cost, 0);
    _total += _packages_data.singles.reduce((p, e) => p + e.cost, 0);

    let commercial = {
      id: _commercial.id,
      active: _commercial.active,
      status: _commercial.status,
      aporte_retirada: !!_budget?.aporte_retirada || false,
      ...(budgetSelect !== "new" && {
        budget: {
          data: _commercial.budget,
          main: _budget ? _budget.id : null,
          selected: {
            name: _budget && _budget.name,
            description: _budget && _budget.description,
            id: _budget && _budget.id,
            main: _budget && _budget.main,
            aporte: _budget?.aporte,
            retirada: _budget?.retirada,
          },
        },
      }),
      ...(budgetSelect === "new" && {
        budget: {
          data: [],
          main: null,
          selected: {
            name: null,
            description: null,
            id: null,
            main: null,
          },
        },
      }),
      institution: {
        id: _commercial.institution?.id,
        institution: _commercial.institution ? _commercial.institution.title : "",
        year: _commercial.year,
        period: _commercial.period,
        name: `${_commercial.course ? _commercial.course.title : "?"} ${_commercial.year}.${_commercial.period} (${
          _commercial.institution ? _commercial.institution.title : "?"
        })`,
        description: _commercial.description || "",
        course: {
          id: _commercial.course.id,
          name: _commercial.course.title,
        },
        campus: {
          id: _commercial.institution ? _commercial.institution.campus_id : null,
          name: _commercial.institution ? _commercial.institution.campus_name : "?",
        },
        location: {
          city: _commercial.institution?.city ? _commercial.institution.city?.id : null,
          state: _commercial.institution?.city ? _commercial.institution.city?.state_id : null,
        },
      },
      files: _commercial.files,
      // Campo legado (turma inteira, sem saber a qual evento pertence) — substituído pela Base
      // por evento na planilha de custos. Preserva null (nunca preenchido) em vez de virar 0,
      // pra dar pra distinguir "turma nova" de "turma antiga com 0 preenchido de propósito".
      invites_trainees: _commercial.invites_trainees != null ? parseInt(_commercial.invites_trainees) : null,
      ticket_trainees: _commercial.ticket_trainees != null ? parseInt(_commercial.ticket_trainees) : null,
      total_trainees: parseInt(_commercial.total_trainees),
      min_payment: parseInt(_commercial.min_payment),
      step_id: _commercial.is_class ? "is_class" : _commercial.step_id,
      is_class: _commercial.is_class,
      trainees: _all_trainees,
      // conta pelo campo `cancel`, e não pelo rótulo de Vínculo: com o status
      // unificado, "Ativo" passou a ser só o último estágio de entrada, então
      // quem está em "Aguardando Aprovação"/"Aguardando Aceite" sairia da
      // contagem — formando da turma que sempre contou aqui
      trainees_active: _all_trainees?.filter(__trainee => !__trainee?.cancel)?.length || 0,
      packages_data: {
        packages: _packages_data.packages,
        singles: _packages_data.singles,
        events: _all_events,
        resources: _all_resources,
        categories: [],
        supliers: _supliers,
      },
      before_event: _before_event,
      first_event: _first_event,
      date_end: !!_commercial?.date_end ? stringToDate(_commercial?.date_end) : null,
      date_start: !!_commercial?.date_start ? stringToDate(_commercial?.date_start) : null,
      wallet: _wallet,
      cost: _total,
      code_access: _commercial.code_access,
      created_at: _commercial.created_at,
      comission: _commercial.tempTrainees,
      negotiation: {
        quota_first: _commercial.date_start,
        quota_last: _commercial.date_end,
        quotas: parseInt(_commercial.min_payment),
        total_trainees: parseInt(_commercial.total_trainees),
        channel_marketing: _commercial.channel_marketing,
        ideal_payment: _commercial.ideal_payment,
      },
      updated_at: stringToDate(_commercial.updated_at),
      seller: _commercial.user_id,
      legacy_id: _commercial.legacy_id,
      whatsapp_link: _commercial.whatsapp_link,
      became_class: _commercial.became_class,
      custom_payments: _custom_payments,
      products: _products,
      contract_number_legacy: _commercial.contract_number_legacy,
      label: `${_commercial?.course?.title} ${_commercial?.year}.${_commercial?.period} - ${
        _commercial?.institution ? _commercial?.institution?.title : "?"
      }${!!_commercial.contract_number_legacy ? ` (${_commercial.contract_number_legacy})` : ""}`,
    };

    return commercial;
  } else {
    const _params = params || "?is_class=1&joins=institution,course,package,single,trainee";
    const _commercial = await api.get(`commercial${isReport ? "/general/report/" : ""}${_params}`, config);

    let _commercial_data = _commercial.data.data || _commercial.data;
    _commercial_data = _commercial_data.map(__commercial => ({
      label: `${__commercial?.course?.title} ${__commercial?.institution?.title || "?"} ${__commercial?.year}.${
        __commercial?.period
      } ${!!__commercial?.contract_number_legacy ? ` - ${__commercial?.contract_number_legacy}` : ""}`,
      value: __commercial?.id,
      has_trainee_package:
        (__commercial?.package?.length > 0 || __commercial?.single?.length > 0) &&
        __commercial?.__meta__?.total_trainees_count > 0,
      status:
        __commercial?.status === "ended"
          ? "Finalizada"
          : __commercial?.status === "trade-canceled"
            ? "Cancelada"
            : __commercial?.active
              ? "Ativa"
              : "Cancelada",
      ...(__commercial?.status === "trade-canceled" && {
        cancel_reason: __commercial?.reason,
        cancel_obs: __commercial?.obs,
      }),
      ...(__commercial?.reason === "concorrencia" && { competitor: __commercial?.concurrents }),
      ...(__commercial?.reason === "outro" && { cancel_reason_obs: __commercial?.reason_obs }),
      total_trainees: __commercial?.total_trainees,
      seller: __commercial?.user_id,
      is_class: __commercial?.is_class,
      trainee_expectation: __commercial?.total_trainees || 0,
      trainee_signeds: __commercial?.trainee?.filter(__trainee => !__trainee.cancel)?.length || 0,
      trainees: __commercial?.trainee || [],
      trainees_count: {
        total: __commercial?.__meta__?.total_trainees_count || 0,
      },
      budget_expectation: 0,
      budget_payed: 0,
      year: Number(__commercial?.year) || null,
      pediod: Number(__commercial?.period) || null,
      contract_number_legacy: __commercial?.contract_number_legacy,
    }));

    if (_commercial.data.data) {
      return {
        ..._commercial.data,
        data: _commercial_data,
      };
    } else {
      return _commercial_data;
    }
  }
}
